import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
import cloneDeep from 'lodash/cloneDeep'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

export default {
  data() {
    const getInTouchDefaultState = {
      firstName: '',
      lastName: '',
      email: '',
      tel: '',
      message: '',
      terms: '',
    }

    return {
      getInTouchDefaultState,
      getInTouch: cloneDeep(getInTouchDefaultState),
      getInTouchErrors: {},
      isBusy: false,
    }
  },
  methods: {
    getInTouchHandleSubmit(e) {
      this.getInTouchValidate()

      if (Object.keys(this.getInTouchErrors).length === 0) {
        const submitObject = {
          ...this.getInTouch,
        }

        const form = e.target

        if (!this.isBusy && form.action) {
          this.isBusy = true
          fetch(form.action, {
            method: form.method || 'post',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(submitObject),
            redirect: 'follow',
          }).then(res => {
            this.isBusy = false
            if (!res.ok) {
              alert('Error. The form was not sent.')
            }
            if (res.redirected) {
              window.location.href = res.url
            }
          })
        }
      }
    },

    getInTouchValidate() {
      const newErrors = {}

      this.getInTouchErrors = newErrors
      Object.keys(this.getInTouch).forEach(key => {
        if (!this.getInTouch[key]) newErrors[key] = true
      })

      this.getInTouchErrors = newErrors
    },
  },
}
